import React from 'react';
import { ValidationProps } from 'ui';
import { DialogExpander } from 'ui/common/dialog-expander/dialog-expander';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { SavedReportForm } from '../../components/saved-report-form';
import { SavedReport } from '../../types-store';
import { SavedReportsTranslation, SavedReportsEndpoints } from '../../constants';

interface SavedReportDetailsProps {
  savedReport: SavedReport;
  displayMySavedReport: boolean;

  updateCurrent: (savedReport: Partial<SavedReport>) => void;

  onHideDetails: () => void;
  onDone: () => void;

  endpoints: SavedReportsEndpoints;

  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    }
  };
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;

  locale: string;
  validation: { [T in keyof SavedReport]?: ValidationProps };
  translation: SavedReportsTranslation;
}

export const SavedReportDetails: React.FC<SavedReportDetailsProps> = ({
  savedReport, displayMySavedReport, updateCurrent, onDone, onHideDetails,
  endpoints, options, loadOptions,
  locale, validation, translation
}) => {

  return <DialogExpander
    onClose={onHideDetails}
    onConfirm={onDone}
    textDone={translation.done}
    disabled={!savedReport?.code?.value}
    className="tile-details-view">
    <SavedReportForm
      savedReport={savedReport}
      displayMySavedReport={displayMySavedReport}
      updateCurrent={updateCurrent}
      endpoints={endpoints}
      options={options}
      loadOptions={loadOptions}
      locale={locale}
      validation={validation}
      translation={translation} />
  </DialogExpander>;
};
